module.exports = __webpack_public_path__ + "img/bbva-logo.09c461ee.jpg";